module.exports = __webpack_public_path__ + "img/dimequest-map-wire.54dc53c2.png";